import {marked} from 'marked';
import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import store from '../store';
import {setModalActive} from '../slices/statusSlice';
import close from '../../icons/close';

@customElement('modal-view')
export class ModalView extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		z-index: 20;
	  }
	  @keyframes reveal {
		from {
		  opacity: 0;
		}

		to {
		  opacity: 100%;
		}
	  }
	  @keyframes slide {
		from {
		  transform: translateX(100px);
		}

		to {
		  transform: translateX(0px);
		}
	  }
	  .modal {
		font-family: var(--font-family-light);
		position: absolute;
		height: 100%;
		width: 100%;
		left: 0;
		top: 0;
		display: flex;
		justify-content: flex-end;
		background-color: rgba(0, 0, 0, 0.75);
		opacity: 100%;
		animation: reveal 0.25s ease-out normal forwards;
	  }

	  .close {
		color: var(--color-black);
		background-color: transparent;
		border: none;
		cursor: pointer;
		height: 20px;
	  }
	  .close svg {
		pointer-events: none;
	  }
	  .close svg * {
		stroke: currentColor;
	  }

	  .panel {
		padding: var(--large-padding);
		background-color: var(--color-grey1);
		width: 50vw;
		animation: slide 0.25s ease-out normal forwards;
		display: flex;
		flex-direction: row;
		gap: var(--large-padding);
	  }

	  .content {
		overflow-y: auto;
		height: 100%;
		flex-basis: 67%;
	  }
	  .content p,
	  .content ul,
	  .content ol,
	  .content blockquote,
	  .content pre {
		font: var(--font-light);
	  }
	  .content img {
		max-width: 100%;
	  }
	  .title {
		font: var(--font-modal-title);
		flex-basis: 32%;
	  }

	  @media (max-width: 768px) {
		.panel {
		  width: 100vw;
		  flex-direction: column;
		}
		.content {
		  flex-basis: 100%;
		}
		.title {
		  flex-basis: 0;
		}
		.close {
		 	position: absolute;
		  	top: var(--large-padding);
		  	right: var(--large-padding);
		}
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.status = state.status;
		this.modalActive = this.status.modalActive;
		this.modalContent = this.status.modalContent;
		this.modalTitle = this.status.modalTitle;
	}

	connectedCallback() {
		super.connectedCallback();
		addEventListener('keydown', this.handleKeydown);
	}

	handleKeydown = (e) => {
		switch (e.keyCode) {
			case 27: // ESC
				if (this.modalActive) {
					this.closemodal();
				}
				break;
		}
	};

	closemodal(e) {
		const targetId = e.target.getAttribute('id');
		if (targetId === 'modal' || targetId === 'close') {
			store.dispatch(setModalActive(
				{
					modalActive: false,
				}
			));
		}
	}

	render() {
		return this.modalActive ? html`
			<div id="modal" class="modal" @click="${this.closemodal}">
				<div class="panel">
					<div class="title">
						${this.modalTitle}
					</div>
					<div class="content">
						${unsafeHTML(marked(this.modalContent))}
					</div>
					<button id="close" @click="${this.closemodal}" class="close">
						${close}
					</button>
				</div>
			</div>
		` : null;
	}
}
